import {firebaseConfig} from './realtimedb-utils';
export const storageBucket = (undefined !== firebaseConfig && undefined !== firebaseConfig.hosting)
    ? firebaseConfig.hosting
    : null;
export const hosting = (undefined !== firebaseConfig && undefined !== firebaseConfig.hosting)
    ? firebaseConfig.hosting
    : process.env.PUBLIC_URL;
